<div class="form-group mb-3" [formGroup]="parentForm()">
  <div class="form-check custom-checkbox">
    <input
      type="checkbox"
      class="form-check-input"
      [id]="id()"
      [formControlName]="formControlProp() ?? null"
    />
    <label class="form-check-label form-label" [for]="id()">{{
      label()
    }}</label>
  </div>
</div>
